<template>
  <GeneralDashboardLayout>
    <template v-slot:header>
      <div class="header-template">
        <BackButton :to="{ name: 'events.index' }" />
        <h1 class="header--title">{{item.title}}</h1>
        <div>
          <button class="btn btn-outline-light" @click="submitForm">Save Changes</button>
          &nbsp;  <button class="btn btn-outline-light" @click="cancelForm">Cancel</button>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="event-config">
        <div class="leftmenu">
          <aside>
            <ul>
              <li>
                <a href="#general-information">
                  <i class="bx bx-home-alt" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="#color-settings">
                  <i class="bx bxs-palette" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href="#theme-settings">
                  <i class='bx bx-cog'></i>
                </a>
              </li>
            </ul>
          </aside>
        </div>
        <div class="right_content">
          <div class="container-fluid ">
            <div class="row event-config--row" id="event-owner">
              <div class="col-md-3 event-config--description">
                <h3>Event Owner</h3>
                <p>Main owner of the event. Who can controle all the  settings/Configurations</p>
              </div>
              <div class="col-md-9 event-config--fields">
                <EventOwner />
              </div>
            </div>
            <div class="row event-config--row" id="general-information">
              <div class="col-md-3 event-config--description">
                <h3>General Information</h3>
                <p>Main Information about the Event. Edit event start/stop date.</p>
                <p>Add event Location. Time zone and Address.</p>
              </div>
              <div class="col-md-9 event-config--fields">
                <GeneralEventConfigSnippet />
                <StartEndDateSnippet />
                <EventDomainSnippet />
              </div>
            </div>
            <div class="row event-config--row" id="color-settings">
              <div class="col-md-3 event-config--description">
                <h3>Color Settings</h3>
                <p>Theme Color settings. Event Theme settings.</p>
              </div>
              <div class="col-md-9 event-config--fields">
                <AdditionalConfigSnippet />
                <ThemeColorSnippet />
              </div>
            </div>
            <div class="row event-config--row" id="theme-settings">
              <div class="col-md-3 event-config--description">
                <h3>Settings</h3>
                <p>Theme settings. Event Theme settings.</p>
              </div>
              <div class="col-md-9 event-config--fields">
                <EventSubscriptionConfigSnippet />
              </div>
            </div>
          </div>
        </div>
        <FlashMessage group="events_edit"/>
      </div>
    </template>
  </GeneralDashboardLayout>
</template>

<script>
import EventOwner from "@/components/cruds/Events/Forms/Elements/EventOwner";

import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import {mapActions, mapGetters} from "vuex";
import axios from 'axios';
import BackButton from "@/components/Commons/BackButton";
import GeneralEventConfigSnippet from "@/components/cruds/Events/Forms/Elements/GeneralEventConfigSnippet";
import StartEndDateSnippet from "@/components/cruds/Events/Forms/Elements/StartEndDateSnippet";
import EventDomainSnippet from "@/components/cruds/Events/Forms/Elements/EventDomainSnippet";
import AdditionalConfigSnippet from "@/components/cruds/Events/Forms/Elements/AdditionalConfigSnippet";
import ThemeColorSnippet from "@/components/cruds/Events/Forms/Elements/ThemeColorSnippet";
import EventSubscriptionConfigSnippet from "@/components/cruds/Events/Forms/Elements/EventSubscriptionConfigSnippet";
import { gettingErrorMessage } from "@/services/GetValidationMessage";
import {
    useVuelidate
} from '@vuelidate/core'

export default {
  name: "EditEvent",
  components: {
    EventSubscriptionConfigSnippet,
    ThemeColorSnippet,
    AdditionalConfigSnippet,
    EventDomainSnippet,
    StartEndDateSnippet,
    GeneralEventConfigSnippet,
    BackButton,
    GeneralDashboardLayout,
    EventOwner
  },
  data() {
    return {
      //
    }
  },
  setup(){
    return {
            v$: useVuelidate()
        }
  },
  computed: {
    ...mapGetters("AuthenticationsIndex",{checkPermssions:"all", role:"role",isCan:"isCan"}),
    ...mapGetters("EventsSingle", [
      "item",
    ])
  },
  created() {
   // await this.fetchPermissionsOnLoad('virtual_event_edit');
   // if(!this.isCan){
     // alert("You don't have sufficient permission to access this page.");
      //history.back();
   // }
    this.fetchData(this.$route.params.event_id);
    this.fetchCompaniesAll();
    this.fetchCountriesAll();
    this.fetchTimezonesAll();
    this.fetchLanguagesAll();
    this.fetchThemeSettings();
  },
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.events_edit;
    //delete this.$flashMessage.groups.events_index;

  },
  methods: {
    ...mapActions("AuthenticationsIndex",["fetchPermissions","fetchPermissionsOnLoad"]),
    ...mapActions("EventsSingle", [
      "fetchData",
      "updateData",
      "resetState",
      "fetchCountriesAll",
      "fetchTimezonesAll",
      "fetchThemeSettings"
    ]),
    ...mapActions("LanguagesIndex", {
      fetchLanguagesAll: "fetchData"
    }),
    ...mapActions("CompaniesIndex", {fetchCompaniesAll: 'fetchData', resetCompaniesState: "resetState"}),
    redirectIndex(){
        this.$router.push({name: "events.index"});
    },
    async submitForm() {
      const isFormCorrect =  await this.v$.$validate()
      if (!isFormCorrect) return
    
      this.updateData()
          .then((data) => {
            this.$router.push({name: "events.index"}) ;
            setTimeout(() =>  this.cancelEdit(), 1500);
                  
          
          })
          .catch(error => {
            let html = gettingErrorMessage(error);
            this.$flashMessage.show({
              group:  'events_edit',
              type:   'error',
              title:  'Failed',
              text:   html,
              html:   html
            });
          });
    },
    cancelForm() {
      this.$router.push({ name: "events.index"});
    },
    cancelEdit() {
      this.$flashMessage.show({
                  group :   'events_index',
                  type  :   'success',
                  title :   'Event Success',
                  time  :   1000,
                  html  :   '<ul><li>Event has been updated successfully</li></ul>',
                });
      this.resetState();
     
    
    }
  },
}
</script>

<style scoped lang="scss">
.header-template {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  .header--title {
    font-size: 1.6rem;
  }
}

.event-config {
  background-color: #eeeff2;
  display: flex;
  flex-direction: row;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: -30px;

  label {
    font-weight: bold;
    margin-left: 5px;
  }

  .form-group {
    margin-bottom: 10px;
  }
  &--description {
    background-color: #dee1e8;
    color: #9e9e9e;
    padding: 32px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      background-color: #a4a4a4;
      bottom: 3px;
      width: 80%;
      height: 1px;
    }

    h3 {
      color: #797979;
    }
  }

  &--fields {
    padding: 5px 32px;
  }

  .leftmenu {
    position: relative;
    left: 0px;
    height: 100%;
    min-width: 50px;
    display: contents;

    aside {
      background: #3c61b2;
      min-width: 50px;
      ul {
        list-style: none;
        padding-left: 0;
        position: fixed;
        min-width: 50px;
        li {
          text-align: center;
          a {
            color: white;
            display: inline-block;
            width: 100%;
            padding: 10px 0;
            transition: all 0.3s ease-in;

            &:hover {
              color: white;
              background: lighten(#4093e3, 20%);
            }

            &.active {
              background: #4093e3;
            }
          }
        }
      }
    }
  }

  nav {
    padding: 0px;
  }

  .right_content {
    width: 100%;
  }
}
</style>